import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import { ChevronDown } from 'lucide-react'
import { faqs, faqIntro } from '@/content/faq'
import { colors, layout } from '@/theme'
import { Section } from '@/components/ui/Section'
import { Eyebrow } from '@/components/ui/Eyebrow'
import { Breadcrumbs } from '@/components/ui/Breadcrumbs'
import { ContactCTA } from '@/components/sections/ContactCTA'
import { Seo } from '@/components/seo/Seo'
import { JsonLd } from '@/components/seo/JsonLd'

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
}

export function Faq() {
  return (
    <>
      <Seo title="FAQ" path="/faq" description="Answers to common questions about True Forge products, safety standards, ordering, private label and support." />
      <JsonLd data={faqSchema} />

      <Section sx={{ pb: 0 }}>
        <Breadcrumbs items={[{ label: 'Home', to: '/' }, { label: 'FAQ' }]} />
        <Eyebrow>Support</Eyebrow>
        <Typography variant="h1" component="h1" sx={{ maxWidth: 940 }}>
          Frequently asked questions
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mt: 3, maxWidth: layout.contentMaxWidth }}>
          {faqIntro}
        </Typography>
      </Section>

      <Section>
        {faqs.map((f, i) => (
          <Accordion
            key={i}
            disableGutters
            elevation={0}
            square
            sx={{
              bgcolor: 'transparent',
              borderTop: `1px solid ${colors.border}`,
              '&:last-of-type': { borderBottom: `1px solid ${colors.border}` },
              '&::before': { display: 'none' },
            }}
          >
            <AccordionSummary
              expandIcon={<ChevronDown size={20} color={colors.gold} />}
              sx={{ px: 0, py: 1, '& .MuiAccordionSummary-content': { my: 2 } }}
            >
              <Typography variant="h6" component="h2" sx={{ pr: 2 }}>
                {f.q}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pb: 3, pt: 0 }}>
              <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 760, lineHeight: 1.75 }}>
                {f.a}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Section>

      <ContactCTA />
    </>
  )
}
